'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var KeypairIdentityDriver = require('./KeypairIdentityDriver.cjs');

const keypairIdentity = keypair => ({
  install(metaplex) {
    metaplex.identity().setDriver(new KeypairIdentityDriver.KeypairIdentityDriver(keypair));
  }
});

exports.keypairIdentity = keypairIdentity;
//# sourceMappingURL=plugin.cjs.map
